// extracted by mini-css-extract-plugin
module.exports = {"highLight":"HighLight_highLight__COnvE"};